import pick from 'lodash/pick';
/**
 * The Scaler class encapsulates the scaling/unscaling operations needed to make frabic canvas
 * objects appear the correct size.
 */
export default class Scaler {
  constructor(scaleX, scaleY) {
    this.scaleX = parseFloat(scaleX);
    this.scaleY = parseFloat(scaleY);
  }

  /** Return the appropriate size for the canvas
   * Currently we always use 2x, and don't adjust for viewport.
   * In the future this class may need to be given viewport coordinates
   */
  canvasSize(mediaBox) {
    let [ , , w, h] = mediaBox;
    return [w * this.scaleX, h * this.scaleY];
  }

  /** Return the X, Y trim size. We assume the trim box is equal on left/right and top/bottom.
   */
  trimSize(trimBox) {
    let [x, y] = trimBox;
    return [x * this.scaleX, y * this.scaleY];
  }

  /**
   * Load the objects onto the canvas with appropriate scale. Returns a
   * promise. Caller must call renderAll().
   */
  loadScaledObjects(fabricCanvas, objects) {

    // preprocess text. Adds a new "styles" entry to the last character so that the
    // correct font style, color and size shows when the cursor is at the end.
    if(objects.objects){
      objects.objects.forEach(obj => {
        if (typeof obj.styles === 'object' &&
          obj.styles[0] &&
          typeof obj.text === 'string'){

          const styles = obj.styles[0];
          const keys = Object.keys(styles);
          if (keys && keys.length > 0){
            const last = parseInt(keys[keys.length - 1], 10);

            if (obj.text.length > last){
              styles[(last + 1)] = JSON.parse(JSON.stringify(styles[last]));
            }
          }
        }
      });
    }

    return new Promise(resolve => {
      var scaledObjectJson = JSON.stringify(objects, (key, object) => {
        if (typeof object === 'object'){
          object = this.scaleToContainer(object);
        }
        return object;
      });
      fabricCanvas.loadFromJSON(scaledObjectJson, resolve);
    });
  }

  /* (private) Apply scale and other transforms to object. Only affect
   * canvas objects (with a 'type') or style objects (with a 'fontSize')
   */
  scaleToContainer(object, inverse=false) {
    if (object && (object.type || object.fontSize)) {
      object = Object.assign({}, object);
      let pow = inverse ? -1 : 1;
      this.scaleProp(object, 'left', this.scaleX ** pow);
      this.scaleProp(object, 'width', this.scaleX ** pow);
      this.scaleProp(object, 'fontSize', this.scaleY ** pow);
      this.scaleProp(object, 'top', this.scaleY ** pow);
      this.scaleProp(object, 'height', this.scaleY ** pow);
      object.hasRotatingPoint = false;
    }
    return object;
  }

  scaleProp(object, prop, scale) {
    if (object[prop]) object[prop] = parseFloat(object[prop]) * scale;
  }

  unscaledObjects(fabricCanvas) {
    let {objects} = fabricCanvas.toJSON(['brandly']);  // This returns an object despite name.
    let acceptedKeys = [
      'charSpacing',
      'fill',
      'fontSize',
      'fontFamily',
      'id',
      'left',
      'lineHeight',
      'text',
      'textAlign',
      'top',
      'type',
      'styles',
      'width',
      'height',
      'originX',
      'scaleX',
      'scaleY',
      'padding',
      'src',
      'deltaY',
      'brandly'
    ];
    return JSON.parse(JSON.stringify(objects, (key, object) => {
      if (object && (object.type || object.fontSize)) {
        if (object.type === 'image') console.log(object);
        object = this.scaleToContainer(pick(object, acceptedKeys), true);
      }
      return object;
    }));
  }

}



// WEBPACK FOOTER //
// ./src/lib/Scaler.js